<template>
  <div>
    <el-dialog
      :visible.sync="viewDialogVisible"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
      class="bullet-detail"
      :title="$lang('物品明细')"
    >
      <div style="margin-bottom: 20px" v-if="sourceType === 'batchEntry'">
        <el-button type="primary" class="addAddress h40" @click="rowAdd" icon="iconfont el-icon-plus">{{ $lang('新增') }}</el-button>
        <el-button type="primary" class="h40" @click="delHandle" :disabled="!multipleSelection.length" icon="iconfont iconshanchu">{{ $lang('删除') }}</el-button>
      </div>
      <div class="dialog-content">
        <jms-table
          :option="listOpt"
          :data="tableList"
          :page="page"
          :table-loading="loading"
          @row-del="rowDel"
          :tablePageVisible="false"
          @size-change="sizeChange"
          @selection-change="selectionChange"
          @current-change="currentChange"
        >
          <template slot="chineseName" slot-scope="scope">
            <el-input @blur="inputBlur(scope.row.chineseName, 'chineseName')" v-model="scope.row.chineseName" :maxlength="100" :placeholder="$t('请输入内容')"></el-input>
          </template>
          <template slot="englishName" slot-scope="scope">
            <el-input v-model="scope.row.englishName" :maxlength="100" :placeholder="$t('请输入内容')" @blur="inputBlur(scope.row.englishName, 'englishName')"></el-input>
          </template>
          <template slot="goodsNumber" slot-scope="scope">
            <el-input-number :step-strictly="true" v-model="scope.row.goodsNumber" :max="999" @blur="inputBlur(scope.row.goodsNumber, 'goodsNumber')"></el-input-number>
          </template>
          <template slot="goodsValue" slot-scope="scope">
            <el-input v-model="scope.row.goodsValue" :placeholder="$t('请输入内容')" @blur="inputBlur(scope.row.goodsValue, 'goodsValue')"></el-input>
          </template>
          <template slot="pricecurrency" slot-scope="scope">
            <el-select v-model="scope.row.pricecurrency" :placeholder="$t('请选择')">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
            <!-- <el-input v-model="scope.row.pricecurrency" :placeholder="$t('请输入内容')" @blur="inputBlur(scope.row.pricecurrency, 'pricecurrency')"></el-input> -->
          </template>
          <template slot="goodsDesc" slot-scope="scope">
            <el-input v-model="scope.row.goodsDesc" :placeholder="$t('请输入内容')" @blur="inputBlur(scope.row.goodsDesc, 'goodsDesc')"></el-input>
          </template>
          <template slot="goodsUrl" slot-scope="scope">
            <el-input :maxlength="200" @blur="inputBlur(scope.row.goodsUrl, 'goodsUrl')" v-model="scope.row.goodsUrl" :placeholder="$t('请输入内容')"></el-input>
          </template>
          <template slot="hsCode" slot-scope="scope">
            <el-input @blur="inputBlur(scope.row.hsCode, 'hsCode')" v-model="scope.row.hsCode" :placeholder="$t('请输入内容')"></el-input>
          </template>
        </jms-table>
      </div>
      <div slot="footer" style="text-align: center" v-if="sourceType === 'batchEntry'">
        <el-button class="h40" @click="viewDialogVisible = false">{{ $lang('取 消') }}</el-button>
        <el-button :disabled="!tableList.length" type="primary" :loading="keyBtn" @click="editSave" class="h40">{{ $lang('保 存') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mixin from '@/mixins/mixin.js'
import { logList } from '@/api/module/customer'
import { VALIDATION } from '@utils/rules'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'ItemDetail',
  mixins: [mixin],
  props: {
    sourceType: {
      type: String,
      default: ''
    },
    itemList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      viewDialogVisible: false,
      isShowFirst: false,
      COM_HTTP: {
        reqList: logList,
      },
      tableList: [],
      multipleSelection: [],
      options: [
        {
          value: 'AED',
          label: 'AED'
        },
        {
          value: 'SAR',
          label: 'SAR'
        },
        {
          value: 'USD',
          label: 'USD'
        }
      ],
      rules: {
        chineseName: {
          required: true,
          errMsg: '中文品名不能为空'
        },
        englishName: {
          required: true,
          errMsg: '英文品名不能为空'
        },
        goodsNumber: {
          required: true,
          errMsg: '件数不能为空'
        },
        goodsValue: {
          required: true,
          errMsg: '申报价值不能为空'
        },
        pricecurrency: {
          required: true,
          errMsg: '申报价值币别不能为空'
        },
        goodsDesc: {
          required: false,
          errMsg: '物品描述不能为空'
        },
        goodsUrl: {
          validator: VALIDATION.address.value,
          errMsg: VALIDATION.address.label
        },
        hsCode: {
          validator: VALIDATION.code.value,
          errMsg: VALIDATION.code.label
        }
      }
    }
  },
  computed: {
    slotType () {
      return this.sourceType === 'batchEntry'
    },
    listOpt () {
      return {
        border: true,
        selection: true,
        menu: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        // rowKey: '$index',
        fixHeight: 90,
        tableHeight: 450,
        // menuWidth: 150,
        //  搜索框和表格列及其字段
        column: [
          {
            label: '中文品名',
            prop: 'chineseName',
            overHidden: false,
            width: 150,
            slot: this.slotType,
            renderHeader: this.renderHeader

          },
          {
            label: '英文品名',
            prop: 'englishName',
            width: 150,
            overHidden: false,
            slot: this.slotType,
            renderHeader: this.renderHeader
          },
          {
            label: '件数',
            prop: 'goodsNumber',
            width: 150,
            overHidden: false,
            slot: this.slotType,
            renderHeader: this.renderHeader
          },
          {
            label: '申报价值',
            prop: 'goodsValue',
            width: 150,
            overHidden: false,
            slot: this.slotType,
            renderHeader: this.renderHeader
          },
          {
            label: '申报价值币别',
            prop: 'pricecurrency',
            width: 120,
            overHidden: false,
            slot: this.slotType,
            renderHeader: this.renderHeader
          },
          {
            label: '物品描述',
            prop: 'goodsDesc',
            overHidden: false,
            slot: this.slotType
          },
          {
            label: 'URL',
            prop: 'goodsUrl',
            overHidden: false,
            slot: this.slotType
          },
          {
            label: '海关编码',
            prop: 'hsCode',
            width: 150,
            overHidden: false,
            slot: this.slotType
          },
        ],
        rowIndex: 0
      }
    }
  },
  watch: {
    itemList: {
      handler (val) {
        // this.tableList = val
      },
      deep: true,
      immediate: true
    }
  },
  created () {
  },
  methods: {
    renderHeader (h, { column, $index }) {
      return h('span', {}, [
        h('span', {
          class: 'red',
          style: {
            marginRight: '2px'
          }
        }, ['*']),
        h('span', {}, [column.label])
      ])
    },
    showDialog (index, data) {
      this.viewDialogVisible = true
      this.rowIndex = index
      this.tableList = cloneDeep(data)
    },
    hideDialog () {
      this.viewDialogVisible = false
    },
    selectionChange (val) {
      this.multipleSelection = val
    },
    delHandle () {
      this.multipleSelection.map((item, index) => {
        this.tableList.splice(this.tableList.findIndex((colItem) => colItem.$index === item.$index), 1)
      })
      console.log(this.tableList)
    },
    rowAdd () {
      if (this.tableList.length >= 10) {
        this.$msg.error(this.$t('最多可添加10个物品信息'))
        return false
      }
      this.tableList.unshift({
        chineseName: '',
        englishName: '',
        goodsNumber: 0,
        goodsValue: '',
        pricecurrency: '',
        goodsDesc: '',
        goodsUrl: '',
        hsCode: ''
      })
    },
    editSave () {
      console.log('物品明细---->>', this.tableList)
      this.tableList.forEach(row => {
        Object.keys(row).forEach((key) => {
          if (this.rules.hasOwnProperty(key)) {
            this.validatorShowMsg(row[key], key)
          }
        })
      })

      console.log('无误00000000000000000000000')
      this.hideDialog()
      this.$emit('goods-edit-save', this.tableList, this.rowIndex)
    },
    validatorShowMsg (val, key) {
      console.log(val, key)
      const { required, validator, errMsg } = this.rules[key]
      console.log(required, validator, errMsg)
      if (required && (val === '' || val === undefined || val === null)) {
        this.$msg.error(this.$t(errMsg || '请输入'))
        throw new Error('error')
      }
      if ((required || key === 'hsCode') && val && validator && !validator.test(val)) {
        this.$msg.error(this.$t(errMsg))
        throw new Error('error')
      }
      return true
    },
    inputBlur (val, key) {
      const v = this.validatorShowMsg(val, key)
      console.log(v, val, this.rules[key].validator)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper.bullet-detail {
  ::v-deep .el-dialog {
    margin-bottom: 0 !important;
    .el-dialog__body {
      max-height: 600px;
      overflow: auto;
    }
    .el-input,
    .el-input-number {
      width: 100% !important;
    }
  }
  .el-dialog__footer {
    padding: 0;
    margin: 10px 20px 20px;
  }
}
</style>
